/**
 * Top-bar chat icon for AppShell. Reads unread + request counts straight
 * from the shared `MessagingProvider` — no additional REST calls, no
 * duplicate WebSocket subscribers.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { Button } from './ui/button';
import { useMessaging } from '../hooks/messaging-provider';

const MessagesBell = () => {
  const { conversations, requests } = useMessaging();
  const unread = (conversations || []).reduce((n, c) => n + (c.unread || 0), 0);
  const badge = unread + (requests?.length || 0);

  return (
    <Link to="/app/messages" data-testid="topbar-messages-link">
      <Button variant="ghost" size="icon" className="h-9 w-9 relative" title="Messages">
        <MessageSquare className="h-4 w-4" />
        {badge > 0 && (
          <span
            className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[9px] font-bold"
            data-testid="topbar-messages-badge"
          >
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </Button>
    </Link>
  );
};

export default MessagesBell;
